<template>
  <div class="custom-modal-mask" @click.self="onClose">
    <div class="custom-modal-wrapper">
      <div class="custom-modal-container">
        <div v-if="hasHeader" class="custom-modal-header">
          <slot name="header"></slot>
        </div>
        <div class="custom-modal-body">
          <slot name="body"></slot>
        </div>
        <div class="custom-modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  computed: {
    hasHeader() {
      return 'header' in this.$slots;
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style scoped>
.custom-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-modal-wrapper {
  vertical-align: middle;
}

.custom-modal-container {
  width: 70vw;
  max-width: 476px;
  margin: 0px auto;
  border-radius: 2px;
  background-color: white;
}

.custom-modal-header {
  width: 100%;
  height: 90px;
  text-align: center;
  align-items: center;
  line-height: 90px;
  font-size: 20px;
  font-weight: bold;
  color: #464646;
}

.custom-modal-body {
  text-align: right;
}

.custom-modal-footer {
  width: 100%;
}

.custom-modal-footer > div {
  width: 100%;
  display: inline-block;
  text-align: right;
  padding: 10px 10px 10px 10px;
}

@media (max-width: 767px) {
  .custom-modal-container {
    width: 90vw;
  }
}
</style>
